import { Droplet, Barcode, AlertCircle, Fuel } from "lucide-react";

const MEFuelData = ({ latestMeFuelData, fuelId, meFuelType }) => {
  console.log("Latest Main Engine Fuel Data:", latestMeFuelData);
  console.log("meFuelType:", meFuelType);

  const sulfurContentRaw = latestMeFuelData?.sulphurContent ?? "N/A";
  const sulfurContent = sulfurContentRaw.toString().trim();

  const formattedSulfurContent =
    sulfurContent === "N/A"
      ? "N/A"
      : sulfurContent.endsWith("%")
      ? sulfurContent.replace("%", " %")
      : `${sulfurContent} %`;

  const normalizeFuelType = (fuelType) => {
    try {
      if (!fuelType) return "N/A";

      if (Array.isArray(fuelType)) {
        const validFuels = fuelType
          .map((fuel) => {
            if (fuel == null) return "";
            if (typeof fuel === "string") return fuel.trim();
            return String(fuel).trim();
          })
          .filter(
            (fuel) =>
              fuel && fuel !== "N/A" && fuel !== "null" && fuel !== "undefined"
          );

        const uniqueFuels = [...new Set(validFuels)];
        return uniqueFuels.length > 0 ? uniqueFuels.join(", ") : "N/A";
      }

      if (typeof fuelType === "string") {
        const trimmed = fuelType.trim();
        return trimmed && trimmed !== "N/A" ? trimmed : "N/A";
      }

      return String(fuelType || "N/A");
    } catch (error) {
      console.warn("Error normalizing fuel type:", error);
      return "N/A";
    }
  };

  const fuelData = [
    {
      label: "Fuel ID",
      value: fuelId || "N/A",
      icon: <Barcode className="w-4 h-4" />,
      color: "bg-blue-100 text-blue-600",
    },
    {
      label: "Sulfur Content",
      value: formattedSulfurContent,
      icon: <AlertCircle className="w-4 h-4" />,
      color: "bg-orange-100 text-orange-600",
    },
    {
      label: "Fuel Type",
      // value: latestMeFuelData?.fuelType || "VLSFO (RMG 380)",
      value: normalizeFuelType(meFuelType) || "VLSFO (RMG 380)",
      icon: <Fuel className="w-4 h-4" />,
      color: "bg-purple-100 text-purple-600",
    },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between bg-gray-50">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 text-blue-600 rounded-lg">
            <Droplet className="w-5 h-5" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-800">
              Main Engine Fuel
            </h2>
            <p className="text-sm text-gray-500">Current fuel specifications</p>
          </div>
        </div>
      </div>

      {/* Data Grid - Responsive layout */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-0 divide-y md:divide-y-0 md:divide-x divide-gray-100">
        {fuelData.map((item, index) => (
          <div key={index} className="p-5 hover:bg-gray-50 transition-colors">
            <div className="flex items-start gap-3">
              {/* Icon */}
              <div
                className={`p-2 rounded-lg ${item.color} flex-shrink-0 mt-1`}
              >
                {item.icon}
              </div>

              {/* Text Content */}
              <div className="flex flex-col min-w-0 flex-1">
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                  {item.label}
                </span>
                <span
                  className="text-base font-semibold text-gray-800 truncate text-sm"
                  title={item.value}
                >
                  {item.value}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MEFuelData;
